import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

import { TipoInput, ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { CepService } from '../cep/cep.service';
import { IEndereco, IGeom } from '../endereco.interface';
import { EnderecoMapaComponent } from './endereco-mapa/endereco-mapa.component';
import { Location } from '../gis/model/google-maps-geocode-result.interface';
import { GisService } from '../gis/gis.service';
import { GeocodeReversoResult } from '../gis/model/google-maps-geocode-reverso-result.interface';
import { EnderecoUtil } from '../endereco-util';
import { StringUtil } from 'src/app/core/framework/utils/string-util';
import { EnderecoService } from './endereco.service';


@Component({
  selector: 'app-endereco',
  templateUrl: './endereco.component.html',
  styleUrls: ['./endereco.component.css']
})
export class EnderecoComponent implements OnInit, OnChanges {

  @Input() idPaciente: number;
  @Input() exibirBotaoSalvar = false;
  @Input() endereco: IEndereco;

  @ViewChild('enderecoMapa') enderecoMapa: EnderecoMapaComponent;

  @Output() enderecoEventEmitter = new EventEmitter<IEndereco>();
  @Output() enderecoAtualizadoEventEmitter = new EventEmitter<IEndereco>();

  mensagemDeAviso: string;
  locationParaPreencherEndereco: Location;
  novaLocalizacao: Location;

  enderecoUtil = new EnderecoUtil();

  constructor(
    private cepService: CepService,
    private gisService: GisService,
    private toasterService: ToasterService,
    private enderecoService: EnderecoService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes', changes);
    this.enderecoEventEmitter.emit(this.endereco);
  }

  tratarErroCEPNaoEncontrado(toasterId: number, err: any): any {
    this.toasterService.clearWait(toasterId);
    if ( err.status === 404 ) {
      this.toasterService.info('CEP não encontrado', 'Favor conferir o CEP informado');
    }
    return err;
  }

  buscarEnderecoPorCep(): void {
    const toasterId = this.toasterService.wait('Pesquisando endereço...');

    this.cepService.buscarEnderecoPorCEP(this.endereco.cep)
        .pipe(
            catchError(err => this.tratarErroCEPNaoEncontrado(toasterId, err)
          )
        )
        .subscribe((enderecoResultado: IEndereco) => {
          if ( enderecoResultado.cep ) {
            this.endereco.cep = enderecoResultado.cep;
            this.endereco.cidade = enderecoResultado.cidade;
            this.endereco.estado = enderecoResultado.estado;
            this.endereco.pais = enderecoResultado.pais;

            if ( enderecoResultado.logradouro ) {
              this.endereco.logradouro = enderecoResultado.logradouro;
            }

            if ( enderecoResultado.bairro ) {
              this.endereco.bairro = enderecoResultado.bairro;
            }

            this.atualizarMapaComEnderecoEAtribuirEndereco(this.endereco);
          }
          else {
            this.toasterService.info('Endereço não encontrado', 'Favor conferir o CEP informado.');
          }
          this.toasterService.clearWait(toasterId);
        });
  }

  cepKeyUp(): void {
    this.limparEstadoECidade();
  }

  atualizarMapaComEnderecoEAtribuirEndereco(endereco: IEndereco): void {
    if ( !this.endereco.numero ) {
      let subscription: Subscription = null;
      subscription = this.solicitarNumeroResidencia()
                         .subscribe((numeroResidencial: string) => {
                            if ( numeroResidencial ) {
                              this.endereco.numero = numeroResidencial;
                              endereco.numero = numeroResidencial;
                            }
                            this.enderecoMapa.adicionarMarcadorComCep(endereco, true);
                            this.atribuirEndereco(endereco);

                            if ( subscription ) {
                              subscription.unsubscribe();
                            }
                         });
    }
    else {
      this.enderecoMapa.adicionarMarcadorComCep(endereco, true);
      this.atribuirEndereco(endereco);
    }
  }

  novaLocalizacaoEvent(event: Location): void {
    if ( event ) {
      this.endereco.geom = {
        coordinates: {
          lat: '' + event.lat,
          lng: '' + event.lng
        }
      };
    }
    else {
      this.endereco.geom = {
        coordinates: null
      };
    }

    this.changeDetectorRef.detectChanges();
    // this.enderecoEventEmitter.emit(this.endereco);
  }

  adicionarMarcadorEvent(location: Location): void {
    this.novaLocalizacao = location;
    this.changeDetectorRef.detectChanges();
  }

  novaLocalizacaoParaPreencherEnderecoEvent(event: Location): void {
    this.locationParaPreencherEndereco = event;
  }

  preencherEnderecoComBaseNoMapa(): void {
    this.limparEndereco(false);

    const marcador: google.maps.Marker = this.enderecoMapa.getMarcadorHandMapClick();
    this.enderecoMapa.removerTodosOsMarcadores();
    if ( marcador ) {
      this.enderecoMapa.adicionarMarcador({
        lat: marcador.getPosition().lat(),
        lng: marcador.getPosition().lng()
      }, false);
    }

    const lat = this.locationParaPreencherEndereco.lat;
    const lng = this.locationParaPreencherEndereco.lng;

    const toasterId = this.toasterService.wait('Buscando endereço...');

    let geomGeradoPeloGoogleMaps: IGeom = null;

    this.gisService
        .geocodeReverso(lat, lng)
        .pipe(
          map((result: GeocodeReversoResult) => {
            this.locationParaPreencherEndereco = null;
            const endereco: IEndereco = this.enderecoUtil
                                            .extrairEnderecoDoGoogleGeocodeReversoSemCidadeEEstado(result);


            geomGeradoPeloGoogleMaps = endereco.geom;
            return endereco;
          })
          , switchMap((endereco: IEndereco) => {
            return this.cepService.buscarEnderecoPorCEP(endereco.cep)
          })
          , switchMap((endereco: IEndereco) => {
            return this.solicitarNumeroResidencia()
                       .pipe(
                         map((numero: string) => {
                          if ( numero ) {
                            const _numero = StringUtil.extrairNumeros(numero);
                            endereco.numero = ( _numero ? '' + _numero : '' );
                          }

                          return endereco;
                         })
                       )
          })
          , catchError(err => {
            this.toasterService.clearWait(toasterId);
            this.tratarErroCEPNaoEncontrado(toasterId, err);
            return err;
          })
        )
        .subscribe((endereco: IEndereco) => {
          this.toasterService.clearWait(toasterId);

          endereco.geom = geomGeradoPeloGoogleMaps;

          this.atribuirEndereco(endereco);
          // this.enderecoEventEmitter.emit(this.endereco);
        });
  }


  limparEndereco(limparMapa: boolean): void {
    if ( this.endereco ) {
      if ( this.endereco.geom ) {
        if ( this.endereco.geom.coordinates ) {
          this.endereco.geom.coordinates.lat = '';
          this.endereco.geom.coordinates.lng = '';
        }
      }

      this.endereco.logradouro = '';
      this.endereco.numero = '';
      this.endereco.complemento = '';
      this.endereco.bairro = '';
      this.endereco.cep = '';
      this.endereco.cidade = null;
      this.endereco.estado = null;
      this.endereco.pais = '';
    }

    if ( limparMapa ) {
      this.enderecoMapa.removerTodosOsMarcadores();
    }
  }

  limparEstadoECidade(): void {
    this.endereco.cidade = null;
    this.endereco.estado = null;
  }

  atribuirEndereco(o: IEndereco): void {
    if ( this.endereco ) {
      this.endereco.geom = o.geom;
      this.endereco.logradouro = o.logradouro;
      this.endereco.numero = o.numero;
      this.endereco.complemento = o.complemento;
      this.endereco.bairro = o.bairro;
      this.endereco.cep = o.cep;
      this.endereco.cidade = o.cidade;
      this.endereco.estado = o.estado;
      this.endereco.pais = o.pais;
    }
  }

  solicitarNumeroResidencia(): Observable<string> {
    const $toasterQuestion = this.toasterService
                                 .abrirPopupComInputs(
                                  '',
                                  'Qual o número da residência?',
                                  'Confirmar',
                                  'Não sei',
                                  TipoInput.NUMBER
                                 )
                                 .pipe(
                                   map((inputs: HTMLInputElement[]) => {
                                    let numeroResidencial = '';
                                    if ( inputs && inputs[0]) {
                                      const input = inputs[0];
                                      numeroResidencial = input.value;
                                    }

                                    return numeroResidencial;
                                   })
                                 );
    return $toasterQuestion;
  }

  enderecoEstaValido() {
    return EnderecoUtil.verificarEndereco(this.endereco);
  }

  salvarEndereco(): void {
    if ( this.idPaciente ) {
      this.enderecoService
          .atualizar(this.idPaciente, this.endereco)
          .subscribe((endereco: IEndereco) => {
            this.endereco = endereco;
            this.enderecoAtualizadoEventEmitter.emit(endereco);
          });
    }
    else {
      this.toasterService.warning('Operação não realizada', 'O paciente não foi definido');
    }
  }


  /*
  estadoOnChange(event: any): void {
    const estadoSelecionado: Estado = event.value;
    this.limparAutocompleteCidade();
  }
  carregarEstados(): void {
    const estadoFilter: EstadoFilter = {
      status: Status.ATIVO
    }
    this.estadoService
        .listar(estadoFilter)
        .subscribe((resultset: ListaResultset<Estado>) => {
          this.estados = resultset.content;
        });
  }
  limparAutocompleteCidade(): void {
    this.autocompleteCidade.clear();
  }
  configurarAutocompleteCidade(): void {
    const cidadeFilter: CidadeFilter = {
      status: Status.ATIVO,
      sort: ['nome,asc']
    };
    const autobuscarCampo = 'nome';
    this.autocompleteCidade = new MyAutocomplete(
      this.httpClient,
      this.errorHandlerService,
      CidadeService.URL,
      null,
      cidadeFilter,
      autobuscarCampo
    );
  }
  */

}
